/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    declare var siteConfigurationSelf: SiteConfigurationModel;

    export class SiteConfigurationDto {
        Id: string;
        SiteName: string;
        ShowHeaderAfterLogIn: boolean;
        HeaderHtml: string;
        LeftTitleHtml: string;
        RightTitleHtml: string;
        ShowFooter: boolean;
        FooterHtml: string;
        HomeContentPageId: string;
    }

    export class SiteConfigurationModel{

        public siteConfiguration: Wars.Domain.Model.Dtos.SiteConfigurationDto;
        public contentPageDtos: Wars.Domain.Model.Dtos.ContentPageDto[];

        constructor(
            private siteConfigurationService: warsApp.services.SiteConfigurationService,
            private contentPageService: warsApp.services.ContentPageService) {
            siteConfigurationSelf = this;
            siteConfigurationSelf.siteConfigurationService.getSiteConfigurationForConfiguration()
                .then(c => {
                    if (c.id) {
                        siteConfigurationSelf.siteConfiguration = c;
                    } else {
                        siteConfigurationSelf.siteConfigurationService.addSiteConfiguration(siteConfigurationSelf.siteConfiguration)
                            .then((siteConfiguration) => {
                                siteConfigurationSelf.siteConfiguration = siteConfiguration;
                            });
                    }
                });

            siteConfigurationSelf.contentPageService.getContentPagesForConfiguration()
                .then(pages => {
                    siteConfigurationSelf.contentPageDtos = pages;
                });
        }

        public update() {
            siteConfigurationSelf.siteConfigurationService.updateSiteConfiguration(siteConfigurationSelf.siteConfiguration);
        }
    }
}